export class Constants {
	// Input types
	public static InputType = 142;

	public static InputTypePassFail = 143;

	public static InputTypeRatingScale = 144;

	public static InputTypeYesNo = 153;

	public static InputTypeSingleSelection = 154;

	public static InputTypeMultipleSelection = 155;

	public static InputTypeText = 156;

	public static InputTypeOrderSelection = 157;

	public static InputTypeNumeric = 171;

	public static GroupUids = {
		EVERYONE: '281fb7e4-d24d-48fe-87b4-1034456420c4',
		ADMINISTRATORS: '4E976A05-F3E5-4207-A163-0017D2586E56',
		SUPER_USERS: '63CB6F58-F82F-49AF-A954-CF85398946F4',
		EXTERNAL_ADMINISTRATORS: '8edb6e81-3f25-4ac5-bd7b-2879c862d3ba',
	};
}
